<app-review-wrapper title="Messages" [complete]="messages.length > 0" (onEdit)="navigateToUrl()">
  @if (messages.length) {
    <ol class="rs__items">
      @for (message of messages; track message.id) {
        <li class="rs__item">
          <div class="rs__item-head">
            <p class="rs__item-title">{{ message.subject || "Untitled message" }}</p>
            <span class="rs__item-meta">{{ metaFor(message) }}</span>
          </div>
          <div class="rs__bubble">
            <bk-sms-bubble [text]="message.body" />
          </div>
        </li>
      }
    </ol>
  } @else {
    <p class="rs__lead">No messages yet.</p>
  }
</app-review-wrapper>
